import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmacao-dialog',
  templateUrl: './confirmacao-dialog.component.html',
  styleUrls: ['./confirmacao-dialog.component.css']
})
export class ConfirmacaoDialogComponent {
  titulo: string;
  messagem: string;
  parametro: any;
 
  constructor(public dialogRef: MatDialogRef<ConfirmacaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.titulo = data.titulo;
    this.messagem = data.messagem;    
  }
  
  onConfirm(): void {
    this.dialogRef.close(true);
  }
 
  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class ConfirmacaoDialogModel { 
  constructor(public titulo: string, public messagem: string) { }
}
